import type { MediaItem } from "~/features/mediaLibrary/types/mediaLibraryTypes";
import MediaLibraryItem from "../MediaLibraryItem/MediaLibraryItem";
import Spinner from "~/common/components/Spinner/Spinner";
import NoMediaFound from "../NoMediaFound/NoMediaFound";
import { Box, useTheme } from "~/common/mui";

export default function MediaList(props: {
  mediaItems: MediaItem[];
  loading: boolean;
  isDownloading: boolean;
  handleCardClick: (media: MediaItem) => void;
  handleFavouriteClick: (id: string, updatedFav: boolean) => void;
  handleDownload: (media: MediaItem) => void;
  sds?: boolean;
}) {
  const { mediaItems, loading, handleCardClick, handleFavouriteClick, handleDownload, sds, isDownloading } = props;
  const theme = useTheme();

  if (!loading && mediaItems.length === 0) {
    return <NoMediaFound />;
  }

  return (
    <Box sx={{ minHeight: "50vh" }}>
      <Box
        sx={{
          display: "grid",
          columnGap: 3,
          rowGap: 4,
          mt: 3.5,
          width: 1,
          gridTemplateColumns: "repeat(4, 1fr)",
          [theme.breakpoints.down("desktop-s")]: {
            gridTemplateColumns: "repeat(3, 1fr)",
          },
          [theme.breakpoints.down("tablet")]: {
            gridTemplateColumns: "repeat(2, 1fr)",
          },
          [theme.breakpoints.down("phone")]: {
            gridTemplateColumns: "1fr",
          },
        }}
      >
        {(!loading || mediaItems.length > 0) &&
          mediaItems.map((item) => (
            <MediaLibraryItem
              media={item}
              key={item.id}
              handleCardClick={handleCardClick}
              handleFavouriteClick={handleFavouriteClick}
              handleDownload={handleDownload}
              isDownloading={isDownloading}
            />
          ))}
      </Box>
      {loading && (
        <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-start" }}>
          <Spinner />
        </Box>
      )}
    </Box>
  );
}
